import './FilterOptionsList.scss';

import { X } from '@phosphor-icons/react';
import { ButtonV2 } from '@travelwin/core';
import { PropsWithChildren } from 'react';
import { useTranslation } from 'react-i18next';

const className = 'p-FilterOptionsList';

type FilterOptionsListProps = PropsWithChildren<{
  onClear: () => void;
  showClearButton?: boolean;
  onClose: () => void;
}>;

export const FilterOptionsList = ({
  onClear,
  showClearButton,
  children,
  onClose,
}: FilterOptionsListProps) => {
  const { t } = useTranslation();

  return (
    <div className={className}>
      <div className={`${className}__header`}>
        <button
          type="button"
          className={`${className}__close-button`}
          onClick={onClose}
        >
          <X size={24} />
        </button>
      </div>
      {children}
      <div className={`${className}__apply-clear-container`}>
        {showClearButton && (
          <ButtonV2
            size="medium"
            variant="secondary"
            intent="brand-green"
            onClick={onClear}
          >
            {t('filter.clear', 'Clear')}
          </ButtonV2>
        )}
      </div>
    </div>
  );
};

export default FilterOptionsList;
